module.exports = __webpack_public_path__ + "static/Portfolio08-491fa010d65ef46381924db26a68d7fd.jpg";